import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=2d8bde0e&scoped=true"
import script from "./infoList.vue?vue&type=script&lang=js"
export * from "./infoList.vue?vue&type=script&lang=js"
import style0 from "./infoList.vue?vue&type=style&index=0&id=2d8bde0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8bde0e",
  null
  
)

export default component.exports